import { useState } from "react";
import { Button } from "@mui/material";
import { setAuthToken } from "../utils/tokenHeaders";
import { useSelector } from "react-redux";
import AppPageShell from "./AppPageShell";

const prodURL = "/api";
const url =
  window.location.hostname === "localhost"
    ? "http://localhost:3004/api"
    : prodURL;

export default function Price() {
  const user = useSelector((state) => state.user?.data);

  const [data] = useState([
    {
      id: 1,
      value: 10,
      price: 500,
      text: "Стартовый набор",
      description: "Достаточно чтобы попробовать",
    },
    {
      id: 2,
      value: 25,
      price: 1125,
      text: "Выгодный пакет",
      description: "Оптимально для работы",
    },
    {
      id: 3,
      value: 50,
      price: 2000,
      text: "Максимальная выгода",
      description: "Для большой аудитории",
    },
  ]);

  const handlePayment = async (el) => {
    const response = await fetch(`${url}/payment/create-payment`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: setAuthToken(),
      },
      body: JSON.stringify({
        id: user?.user?.id,
        price: el.price,
      }),
    });

    const result = await response.json();

    if (result.confirmation?.confirmation_url) {
      window.open(result.confirmation.confirmation_url, "_blank");
    }
  };

  return (
    <AppPageShell
      title="Магазин ключей"
      subtitle="Выберите пакет, который подходит для ваших задач"
    >
      <div className="app-price-grid">
        {data.map((el) => (
          <div className="app-price-card" key={el.id}>
            <div className="app-price-card__title">{el.text}</div>
            <div className="app-price-card__badge">
              <span>Ключей:</span>
              <span>{el.value}</span>
            </div>
            <div className="app-price-card__desc">{el.description}</div>
            <div className="app-price-card__row">
              <span>Цена:</span>
              <span>
                {el.price} &#8381;
              </span>
            </div>
            <div className="app-price-card__row">
              <span>Цена за один ключ:</span>
              <span>
                {el.price / el.value} &#8381;
              </span>
            </div>
            <Button
              variant="contained"
              className="app-btn app-btn--primary"
              onClick={() => handlePayment(el)}
            >
              Купить
            </Button>
          </div>
        ))}
      </div>

      <div className="app-price-note">
        <div>
          Оплата производится при техническом участии —{" "}
          <a href="https://yoomoney.ru" target="_blank" rel="noreferrer">
            ЮMoney
          </a>
        </div>
        <div>
          Обработка платежа может занимать время (точные сроки можно уточнить
          на сайте ЮMoney)
        </div>
        <div>
          После подтверждения платежа со стороны платёжной системы, веб-сервисом
          будет начислен пакет ключей
        </div>
        <div>В случае возникновения проблем, можете написать в поддержку</div>
      </div>
    </AppPageShell>
  );
}
